import { AxiosError, AxiosResponse } from "axios";
import { all, call, put, takeLatest } from "redux-saga/effects";
import {
  fetchTopUpCreateSuccess,
  fetchTopUpCreateFailure,
  fetchTopUpConfirmSuccess,
  fetchTopUpConfirmFailure,
  fetchTopUpAuthorizationSuccess,
  fetchTopUpAuthorizationFailure,
  fetchTopUpCustomerInfoSuccess,
  fetchTopUpCustomerInfoFailure,
  fetchTopUpInfoSuccess,
  fetchTopUpInfoFailure,
  fetchTopUpMakeFeeSuccess,
  fetchTopUpMakeFeeFailure,
} from "./actions";
import {
  FETCH_TOP_UP_CREATE_REQUEST,
  FETCH_TOP_UP_CONFIRM_REQUEST,
  FETCH_TOP_UP_AUTHORIZATION_KEY_REQUEST,
  FETCH_TOP_UP_CUSTOMER_INFO_REQUEST,
  FETCH_TOP_UP_INFO_REQUEST,
  FETCH_TOP_UP_MAKE_FEE_REQUEST,
} from "./actions.type";

import {
  fetchTopUpCreateService,
  fetchTopUpConfirmService,
  fetchTopUpAuthService,
  fetchTopUpInfoService,
} from "../services/top-up.service";
import {
  FetchTopUpCustomerInfoRequest,
  FetchTopUpAuthorizationRequest,
  FetchTopUpConfirmRequest,
  FetchTopUpCreateRequest,
  FetchTopUpMakeFeeRequest,
} from "./types";
import { RESPONSEBASE } from "app/shared/services/services-model.type";
import { getErrorEndOTP, getErrorMessage } from "app/shared/services/axios";
import { hideModal, showModal } from "app/modules/modal-management/reducer/action";

function* fetchTopUpInfoSaga() {
  try {
    yield put(showModal({ modalProps: { open: true }, modalType: "loading" }));
    const response: AxiosResponse<RESPONSEBASE> = yield call(fetchTopUpInfoService);
    console.log("fetchTopUpInfo response: ", response);
    yield put(hideModal());
    if (response.status === 200) {
      yield put(fetchTopUpInfoSuccess(response.data.RESPONSEDATA));
    }
  } catch (e: any | AxiosError) {
    yield put(hideModal());
    const msg = getErrorMessage(e, true);
    yield put(fetchTopUpInfoFailure(msg));
  }
}

function* fetchTopUpMakeFeeSaga(action: FetchTopUpMakeFeeRequest) {
  try {
    yield put(showModal({ modalProps: { open: true }, modalType: "loading" }));
    const response: AxiosResponse<RESPONSEBASE> = yield call(() => fetchTopUpCreateService(action.payload));
    console.log("fetchTopUpMakeFee response: ", response);
    yield put(hideModal());
    if (response.status === 200) {
      yield put(fetchTopUpMakeFeeSuccess(response.data.RESPONSEDATA));
    }
  } catch (e: any | AxiosError) {
    yield put(hideModal());
    const msg = getErrorMessage(e, true);
    yield put(fetchTopUpMakeFeeFailure(msg));
  }
}

function* fetchTopUpCustomerInfoSaga(action: FetchTopUpCustomerInfoRequest) {
  try {
    yield put(showModal({ modalProps: { open: true }, modalType: "loading" }));
    const response: AxiosResponse<RESPONSEBASE> = yield call(() => fetchTopUpCreateService(action.payload));
    console.log("fetchTopUpCustomerInfo response: ", response);
    yield put(hideModal());
    if (response.status === 200) {
      const customerInfo = response.data.RESPONSEDATA?.EBINQUIRY;
      yield put(fetchTopUpCustomerInfoSuccess(customerInfo));
    }
  } catch (e: any | AxiosError) {
    yield put(hideModal());
    const msg = getErrorMessage(e, true);
    yield put(fetchTopUpCustomerInfoFailure(msg));
  }
}

function* fetchTopUpCreateSaga(action: FetchTopUpCreateRequest) {
  try {
    yield put(showModal({ modalProps: { open: true }, modalType: "loading" }));
    const response: AxiosResponse<RESPONSEBASE> = yield call(() => fetchTopUpCreateService(action.payload));
    console.log("fetchTopUpCreate response: ", response);
    yield put(hideModal());
    if (response.status === 200) {
      let responseData = response.data.RESPONSEDATA;
      yield put(fetchTopUpCreateSuccess(responseData));
    }
  } catch (e: any | AxiosError) {
    yield put(hideModal());
    const msg = getErrorMessage(e, true);
    yield put(fetchTopUpCreateFailure(msg));
  }
}

function* fetchTopUpConfirmSaga(action: FetchTopUpConfirmRequest) {
  try {
    yield put(showModal({ modalProps: { open: true }, modalType: "loading" }));
    const response: AxiosResponse<RESPONSEBASE> = yield call(() => fetchTopUpConfirmService(action));
    console.log("fetchTopUpConfirm response: ", response);
    yield put(hideModal());
    if (response.status === 200) {
      let responseData = response.data.RESPONSEDATA;
      yield put(fetchTopUpConfirmSuccess(responseData));
    }
  } catch (e: any | AxiosError) {
    yield put(hideModal());
    const msg = getErrorMessage(e, true);
    yield put(fetchTopUpConfirmFailure(msg));
  }
}

function* fetchTopUpAuthSaga(action: FetchTopUpAuthorizationRequest) {
  try {
    yield put(showModal({ modalProps: { open: true }, modalType: "loading" }));
    const response: AxiosResponse<RESPONSEBASE> = yield call(() => fetchTopUpAuthService(action));
    console.log("fetchTopUpAuth response: ", response);
    yield put(hideModal());
    if (response.status === 200) {
      let responseData = response.data.RESPONSEDATA;
      yield put(fetchTopUpAuthorizationSuccess(responseData));
    }
  } catch (e: any | AxiosError) {
    yield put(hideModal());
    const msg = getErrorMessage(e, true);
    yield put(fetchTopUpAuthorizationFailure(getErrorEndOTP(e), msg));
  }
}

function* topUpSaga() {
  yield all([
    takeLatest(FETCH_TOP_UP_INFO_REQUEST, fetchTopUpInfoSaga),
    takeLatest(FETCH_TOP_UP_CUSTOMER_INFO_REQUEST, fetchTopUpCustomerInfoSaga),
    takeLatest(FETCH_TOP_UP_MAKE_FEE_REQUEST, fetchTopUpMakeFeeSaga),
    takeLatest(FETCH_TOP_UP_CREATE_REQUEST, fetchTopUpCreateSaga),
    takeLatest(FETCH_TOP_UP_CONFIRM_REQUEST, fetchTopUpConfirmSaga),
    takeLatest(FETCH_TOP_UP_AUTHORIZATION_KEY_REQUEST, fetchTopUpAuthSaga),
  ]);
}

export default topUpSaga;
